import { computed } from 'vue'
import { useStore } from 'vuex'
import userGetters from '@/store/userModule/getterTypes'
import userActions from '@/store/userModule/actionTypes'
import { UserType } from '@/types'

export default function useUser() {
  const { getters, dispatch } = useStore()

  const user = computed(() => getters[userGetters.USER.NAMESPACED])
  const userFlags = computed(() => user.value?.flags?.userFlags || [])
  const userType = computed<UserType>(
    () => getters[userGetters.USER_TYPE.NAMESPACED]
  )

  const canAccessPremiumFeatures = computed(
    () =>
      userType.value === UserType.PREMIUM ||
      userType.value === UserType.COACH ||
      userType.value === UserType.DOMAIN
  )

  const enabledPowerEdit3 = computed(() => {
    return user.value?.allowPowerEdit
  })

  const allowResumeScan = computed(() => {
    return user.value?.allowResumeScan
  })

  const isOnTrial = computed<boolean>(() => {
    return user.value?.subscription?.status === 'trialing'
  })

  // Methods
  const fetchUser = () => {
    return dispatch(userActions.FETCH_USER.NAMESPACED)
  }

  const checkPowerEditQuota = () => {
    if (userType.value === UserType.FREE && user.value?.matchReportQuota <= 0) {
      throw new Error(
        "You've reached your limit of free scans. Please upgrade to continue."
      )
    }
  }

  return {
    user,
    userType,
    userFlags,
    canAccessPremiumFeatures,
    enabledPowerEdit3,
    isOnTrial,
    allowResumeScan,
    fetchUser,
    checkPowerEditQuota
  }
}
